import React from 'react';
import { connectRange } from 'react-instantsearch-dom';
const AlgoliaHasRangeRefinementContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = AlgoliaHasRangeRefinementContext;
const AlgoliaHasRangeRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    currentRefinement,
    min,
    max
  } = _ref;
  const hasMinRefinement = currentRefinement && currentRefinement.min && currentRefinement.min !== min;
  const hasMaxRefinement = currentRefinement && currentRefinement.max && currentRefinement.max !== max;
  return /*#__PURE__*/React.createElement(Provider, {
    value: !!(hasMinRefinement || hasMaxRefinement)
  }, children);
});
AlgoliaHasRangeRefinement.propTypes = {};
AlgoliaHasRangeRefinement.defaultProps = {};
AlgoliaHasRangeRefinement.displayName = 'AlgoliaHasRangeRefinement';
export default connectRange(AlgoliaHasRangeRefinement);
export { AlgoliaHasRangeRefinementContext };